import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { RoutePaths } from '../../../../core/constants/routes';

@Component({
  selector: 'app-new-roof-cost-footer',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './new-roof-cost-footer.component.html',
  styleUrl: './new-roof-cost-footer.component.scss',
})
export class NewRoofCostFooterComponent {
  links = [
    { name: 'Privacy Policy', route: RoutePaths.PRIVACY_POLICY },
    { name: 'Terms & Conditions', route: RoutePaths.TERMS_AND_CONDITIONS },
    { name: 'Do Not Sell My Details', route: RoutePaths.FCC },
    { name: 'Cookies', route: RoutePaths.COOKIE_POLICY },
  ];
}
